export const SET_LOADING = 'SET_LOADING';
export const SAVE_USER = 'SAVE_USER';
export const SET_IS_ADMIN = 'SET_IS_ADMIN';
export const SET_IS_EDITOR = 'SET_IS_EDITOR';
export const SET_IS_LEAD_PARTNER = 'SET_IS_LEAD_PARTNER';
export const LOGOUT = 'LOGOUT';
export const SET_NAV_HEADER = 'SET_NAV_HEADER';
export const SET_SAVE_BENEFIT = 'SET_SAVE_BENEFIT';
export const SET_SESSION_STARTED_AT = 'SET_SESSION_STARTED_AT';
